import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import homeLogo from "../assets/about.png";
import Particle from "../components/Particle";
import About from "../components/Home/About";
import Type from "../components/Home/Type";
import PageTransition from "../components/PageTransition";

const staggerContainer = {
  animate: {
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.3,
    },
  },
};

const slideInLeft = {
  initial: { opacity: 0, x: -60 },
  animate: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.7, ease: [0.25, 0.46, 0.45, 0.94] },
  },
};

const fadeInUp = {
  initial: { opacity: 0, y: 40 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.25, 0.46, 0.45, 0.94] },
  },
};

const springInRight = {
  initial: { opacity: 0, x: 80, scale: 0.9 },
  animate: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 100,
      damping: 20,
      delay: 0.5,
    },
  },
};

const Home = () => {
  return (
    <PageTransition>
      <section>
        <Container fluid className="home-section" id="home">
          <Particle />
          <Container className="home-content">
            <Row className="align-items-center">
              <Col md={7} className="home-header">
                <motion.div
                  variants={staggerContainer}
                  initial="initial"
                  animate="animate"
                >
                  <motion.h1
                    variants={slideInLeft}
                    style={{ paddingBottom: 15 }}
                    className="heading"
                  >
                    Hi There!{" "}
                    <span className="wave" role="img" aria-labelledby="wave">
                      👋🏻
                    </span>
                  </motion.h1>

                  <motion.h1 variants={fadeInUp} className="heading-name">
                    I'M
                    <strong className="main-name"> Bunty Chakraborty</strong>
                  </motion.h1>

                  <motion.div
                    variants={fadeInUp}
                    style={{ padding: 50, textAlign: "left" }}
                  >
                    <Type />
                  </motion.div>
                </motion.div>
              </Col>

              <Col md={5} style={{ paddingBottom: 20 }}>
                <motion.div
                  variants={springInRight}
                  initial="initial"
                  animate="animate"
                >
                  <motion.img
                    src={homeLogo}
                    alt="home pic"
                    className="img-fluid home-avatar-img"
                    style={{ maxHeight: "450px" }}
                    animate={{
                      y: [0, -12, 0],
                    }}
                    transition={{
                      duration: 4,
                      repeat: Infinity,
                      ease: "easeInOut",
                    }}
                  />
                </motion.div>
              </Col>
            </Row>
          </Container>

          {/* Scroll indicator */}
          <motion.div
            className="scroll-indicator"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.5, duration: 0.8 }}
          >
            <div className="scroll-indicator-dot"></div>
          </motion.div>
        </Container>
        <About />
      </section>
    </PageTransition>
  );
};

export default Home;
